export default function reducer(state = {
  outlet: {
    attributes: {
      "rewards-details": {
        "voucher-type": {name: "", id: ""},
        "voucher-denomination": {name: "", id: ""},
      }
    }

  }, //for OutletView
  store: {},
  relationships: {
    staff_members: []
  },
  newOrderAmount: '',
  fetching: false,
  fetched: false,
  errors: {},
  manualRedemptionError: false
}, action) {
  switch (action.type) {
    case 'GET_OUTLET_PENDING': {
      return {
        ...state,
        errors: {},
        fetching: true,
        fetched: false,
        relationships: {
          staff_members: []
        },
      }
    }
    case 'GET_OUTLET_FULFILLED': {
      const data = action.payLoad.data;
      return {
        ...state,
        fetching: false,
        fetched: true,
        errors: {},
        outlet: data,
        store: data.attributes,
        relationships: {
          staff_members: data.relationships ? data.relationships["staff-members"].data : []
        }
      }
    }
    case 'GET_OUTLET_REJECTED': {
      return {
        ...state,
        // errors: action.payLoad.data.error
        errors: ''
      }
    }
    case 'CLEAR_OUTLET_DELINK': {
      return {
        ...state,
        store: {},
        fetched: false,
        fetching: false
      }
    }
    case 'ORDER_NOW_SENT': {
      return {
        ...state,
        newOrderAmount: action.payLoad
      }
    }
    case 'VOUCHER_REDEMPTION_SUCCESSFUL': {
      return {
        ...state,
        manualRedemptionError: false
      }
    }
    case 'VOUCHER_REDEMPTION_FAILED': {
      return {
        ...state,
        manualRedemptionError: true
      }
    }

    default:
      return {
        ...state,
        errors: {}
      };
  }

  return {...state};
}



// WEBPACK FOOTER //
// ./src/reducers/storeDetailReducer.js